

function Footer() {
    return (
          <footer>
                <section className="footer-area footer__bg section-spacing">
                    <div className="container">
                        <div className="row gy-50">
                            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12">
                                <div className="footer__widget footer__widget-1">
                                    <div className="footer__logo mb-20">
                                        <a href="/"><img src="assets/img/logo/logo-white.png"
                                                alt="img not found"/></a>
                                    </div>
                                    <p className="made-by-text mb-30">

We transform businesses by integrating
cutting edge technology with compelling
creative work</p>
                                {/* <div className="product__review-thumb mb-40">
                                        <img src="assets/img/projects/product-review-1.png" alt="image not found"/>
                                        <img src="assets/img/projects/product-review-2.png" alt="image not found"/>
                                    </div> */}
                                    <div className="social-links">
                                        <ul>

                                            <li>
                                                <a href="https://x.com/mystra_tech" aria-label="twitter" target="_blank" rel="noopener noreferrer"
                                                data-rr-ui-event-key="/" className="nav-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                                                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                                </svg>
                                                </a>
                                            </li>

                                            <li>
                                                <a href="https://www.instagram.com/mystra_tech/" aria-label="Instagram" target="_blank" rel="noopener noreferrer" data-rr-ui-event-key="/"
                                                className="nav-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                                                <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                                                </svg>
                                                </a>
                                            </li>

                                            <li>
                                                <a href="https://in.pinterest.com/mystratech/our-work/" aria-label="facebook" target="_blank" rel="noopener noreferrer" data-rr-ui-event-key="/"
                                                className="nav-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pinterest" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0"/>
                                                </svg>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12">
                                <div className="footer__widget footer__widget-2">
                                    <h4 className="footer__widget-title mb-30">Our Services</h4>
                                    <div className="footer__links">
                                        <ul>
                                            <li><a href="/mystra-service">⁠UI/UX Design</a></li>
                                            <li><a href="/mystra-service">⁠Website Development</a></li>
                                            <li><a href="/mystra-service">⁠App Development (Web and Mobile)</a></li>
                                            <li><a href="/mystra-service">⁠⁠AI Powered Automation</a></li>
                                            <li><a href="/mystra-service">⁠ ⁠Digital Marketing</a></li>
                                            <li><a href="/mystra-service">⁠Maintenance and Upgrades</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                                <div className="footer__widget footer__widget-3">
                                    <h4 className="footer__widget-title mb-30">Company</h4>
                                    <div className="footer__links">
                                        <ul>
                                            <li><a href="/">Home</a></li>
                                            <li><a href="/mystra-about">About us</a></li>
                                            <li><a href="/mystra-service">What We Do</a></li>
                                            <li><a href="/mystra-terms-of-service">Terms</a></li>
                                            <li><a href="/mystra-privacy-policy">privacy policy</a></li>
                                            <li><a href="/mystra-contact">Contact Us</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12">
                                <div className="footer__widget footer__widget-4">
                                    <h4 className="footer__widget-title mb-30">Newsletter</h4>
                                    <p className="mb-20">We’re always on the lookout for the cutting-edge tech and brand
                                        innovations. Join us today.</p>
                                    <div className="joining-form p-relative">
                                        <form action="#">
                                            <div className="input-wrapper mb-30">
                                                <div className="single-input-field field-email">
                                                    <input type="email" placeholder="Enter Mail"/>
                                                </div>
                                                <div className="joining__btn">
                                                    <a href="#" className="circle-icon-btn"><i
                                                            className="fal fa-long-arrow-right"></i></a>
                                                </div>
                                            </div>
                                            <label for="privacy-policy">
                                                <input type="checkbox" id="privacy-policy" style={{display: 'none'}}/>
                                                <span className="check">
                                                    <svg width="18px" height="18px" viewBox="0 0 18 18">
                                                        <path
                                                            d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z">
                                                        </path>
                                                        <polyline points="1 9 7 14 15 4"></polyline>
                                                    </svg>
                                                </span>
                                                I Agree to the Privacy policy
                                            </label>
                                        </form>
                                    </div>
                                    
                                </div>
                            </div> */}

                        </div>
                    </div>
                </section>

               {/* <section className="company-address-area footer__bg">
                    <div className="container">
                        <div className="address-wrapper pt-60 pb-10">
                            <div className="row">
                                <div className="col-lg-3 col-md-6">
                                    <div className="address-box mb-40">
                                        <h4 className="country-name mb-25">Athens</h4>
                                        <div className="address-list">
                                            <ul>
                                                <li>
                                                    <a href="https://maps.google.com" target="_blank">33 Zeppou
                                                        str.GR-16675
                                                        Glyfada,Greece</a>
                                                </li>
                                                <li>
                                                    <a href="tel:+912111042000">+91 211 10 42 000</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="address-box mb-40">
                                        <h4 className="country-name mb-25">United State</h4>
                                        <div className="address-list">
                                            <ul>
                                                <li>
                                                    <a href="https://maps.google.com" target="_blank">333 SE 2nd Avenue,
                                                        Suite
                                                        2067Miami,
                                                        FL</a>
                                                </li>
                                                <li>
                                                    <a href="tel:+012111042000">+01 211 10 42 000</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="address-box mb-40">
                                        <h4 className="country-name mb-25">Philippines</h4>
                                        <div className="address-list">
                                            <ul>
                                                <li>
                                                    <a href="https://maps.google.com" target="_blank">14th Floor,
                                                        Vernida IV
                                                        Bldg.128 L.P.
                                                        Leviste</a>
                                                </li>
                                                <li>
                                                    <a href="tel:+632111042000">+63 211 10 42 000</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="address-box mb-40">
                                        <h4 className="country-name mb-25">Switzerland</h4>
                                        <div className="address-list">
                                            <ul>
                                                <li>
                                                    <a href="https://maps.google.com" target="_blank">Hauptstrasse
                                                        94CH-4147
                                                        Basel,Switzerland</a>
                                                </li>
                                                <li>
                                                    <a href="tel:+912111042196">+91 211 10 42 196</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>  */}


                <div className="copyright-area copyright__bg pb-30 p-relative z-index-1">
                    <div className="container">
                        <div className="footer-top pt-30"></div>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="copyright__text tpl__item-center">
                                    <p>Copyright © 2025 <a target="_blank" href="/">Mystra</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
    )
}

export default Footer